import {
  CHATAI_LOADING_STATUS,
  ChatAIInput,
  useChatContext,
} from '@ltvco/refresh-lib/v2';
import { CameraAltOutlined } from '@mui/icons-material';
import { useEffect } from 'react';

import { theme } from 'theme';

import { FeatureHeader } from '../components/FeatureHeader';
import { FeaturePageShell } from '../components/FeaturePageShell';

import { MessagesContainer } from './MessagesContainer';

export const DamageAnalyzerPage = () => {
  const { messages, loadingStatus, sendMessage, handleFeatureNameChange } =
    useChatContext();

  useEffect(() => {
    handleFeatureNameChange('createVehiclePhotoDamageAnalyzerBot');
  }, [handleFeatureNameChange]);

  return (
    <FeaturePageShell
      header={
        <FeatureHeader
          icon={
            <CameraAltOutlined sx={{ color: theme.palette.primary.main }} />
          }
          title="Photo Damage Analyzer"
        />
      }
      chatInput={
        <ChatAIInput
          isLoading={
            loadingStatus.message !== CHATAI_LOADING_STATUS.IDLE.message
          }
          disabled={messages.length === 0}
        />
      }
    >
      <MessagesContainer
        messages={messages}
        loadingStatus={loadingStatus}
        onSendMessage={sendMessage}
      />
    </FeaturePageShell>
  );
};
